import { render } from "./FileNameItem.vue?vue&type=template&id=b4d52758&scoped=true"
import script from "./FileNameItem.vue?vue&type=script&lang=js"
export * from "./FileNameItem.vue?vue&type=script&lang=js"

import "./FileNameItem.vue?vue&type=style&index=0&id=b4d52758&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1697103798/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d52758"]])

export default __exports__